<template>
	<section class="section saved-jobs">
		<div class="container mx-auto">

      <search-sort :modelValue="searchSortData" :sortMenu="sortMenu" placeholder="Search Jobs"></search-sort>

      <div class="saved-jobs__btns" v-if="jobs">
        <button v-if="liveJobs" :class="['btn btn-toggle btn-rounded mr-3 mb-4',{'active':islive}]" @click="islive = true">Live <span class="ml-1 font-normal">({{liveJobs.length}})</span></button>
        <button v-if="expiredJobs" :class="['btn btn-toggle btn-rounded',{'active':!islive}]" @click="islive = false">Expired <span class="ml-1 font-normal">({{expiredJobs.length}})</span></button>
      </div>

      <div class="saved-jobs-cards">
				<template v-if="!me">
					You must be signed in to see applications
				</template>
				<template v-else-if="!jobs">
					Loading...
				</template>
				<template v-else>
          <template v-if="computedJobs.length == 0">
            <div class="saved-jobs-card__outter">
              <p>No jobs found</p>
            </div>
          </template>
          <template v-else v-for="(result, j) in computedJobs" :key="`job_saved_${result['objectID']}`">
            <block-job-card-slim :payload="result"></block-job-card-slim>
          </template>
				</template>

			</div>
		</div>
	</section>
</template>

<script>
import algoliasearch from 'algoliasearch';
import AuthMixins from '@/mixins/AuthMixins';
import SearchSort from './partials/SearchSort';

export default {
	mixins: [AuthMixins],

  components: {
  	SearchSort
	},

	props: {
		bubble_site_url: {
			type: String
		}
	},

	data() {
		return {
			jobs: false,
      islive: true,

			client: false,
			index: false,
			index_name: (this.$config.test_env) ? 'listings-test-latest' : 'listings-live-latest',
			searchObject: {
				hitsPerPage: 3,
				facets: ['objectID'],
				facetFilters: []
			},
      searchSortData: {search:'', sort:'title_asc'},
      sortMenu: [
        { title: 'Title Ascending', value: 'title_asc', selected: false },
        { title: 'Title Descending', value: 'title_desc', selected: false },
        { title: 'Newest First', value: 'date_desc', selected: false },
        { title: 'Oldest First', value: 'date_asc', selected: false }
      ]
		}
	},

	created() {
		this.emitter.on('close:saved-jobs', this.doClose);
	},
	beforeUnmount() {
		this.emitter.off('close:saved-jobs', this.doClose);
	},

	mounted() {
		if (this.me) {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);
		}
	},

	methods: {
		loadData() {
      console.log('Saved Jobs:', this.computedSavedJobs);
      // Set hitsPerPage to length of this.computedPayload.slugs array.
      // Loop through this.computedPayload.slugs and prefixing them with 'slugs:', then add them to facetFilters.
      this.searchObject.hitsPerPage = this.computedSavedJobs.length;
      this.searchObject.facetFilters.push(this.computedSavedJobs.map(el => `objectID:${el['job-id']}`));

			this.index
				.search('', this.searchObject)
				.then((results) => {
					this.jobs = results.hits;
					console.log("Found jobs",this.jobs)
				});
		},
		doClose(job_alert_id) {
			this.$nextTick(() => {
				this.$refs[job_alert_id].checked = false;
			});
		},
    filterPublishedJobs(state) {
      return Object.values(this.computedFliteredJobs).filter((job) => {
				if (job.published == undefined) {
					return false;
				}
				return job.published == state;
			});
    },
		calcJobLink(result) {
			if (result['slug'] == undefined || result['slug'] == '') {
				return `/opportunity/redirect/${result['objectID']}`;
			}
			return `/opportunity/${result['slug']}`;
		},
    refreshFilters() {
      switch (this.searchSortData.sort) {
        case 'title_asc':
        this.jobs.sort((a, b) => a['job-title'].toLowerCase().localeCompare(b['job-title'].toLowerCase()));
          break;
        case 'title_desc':
        this.jobs.sort((a, b) => b['job-title'].toLowerCase().localeCompare(a['job-title'].toLowerCase()));
          break;
        case 'date_asc':
        this.jobs.sort((a, b) => a['posted-date'] - b['posted-date']);
          break;
        case 'date_desc':
        this.jobs.sort((a, b) => b['posted-date'] - a['posted-date']);
          break;
      }
    }
	},

  computed: {
    liveJobs() {
      return this.filterPublishedJobs(true);
    },
    expiredJobs() {
      return this.filterPublishedJobs(false);
    },
    computedJobs() {
      return this.islive ? this.liveJobs : this.expiredJobs;
    },
    computedSavedJobs() {
      return this.me["saved-jobs"];
    },
    computedFliteredJobs() {
      return this.jobs.filter(v => {
        return v['job-title'].toLowerCase().includes(this.searchSortData.search.toLowerCase());
      });
    }
  },

  watch: {
    computedSavedJobs(newVal, oldVal) {
      this.$nextTick(() => {
				this.loadData();
			})
    },
    searchSortData: {
      deep:true,
      handler() {
        this.refreshFilters();
      }
    }
  }
}
</script>
